export default __webpack_public_path__ + "static/media/dissatisfied.2c5e4434.svg";